/*
 * @Author: JamesWong
 * @Description: 仓库模块中文包
 * @Date: 2018-11-29 18:56:25
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-12-17 11:22:34
 */
export default {
  authorizedWarehouse: 'Authorized Warehouse',
  deleteWarehouse: 'Delete Warehouse',
  hint: 'Hint',
  deleteWarehouseTips: 'This Warehouse cannot login with POS after deleted，Sure to delete this Warehouse?',
  cancel: 'Cancel',
  confirmDelete: 'Confirm Delete',
  addWarehouse: 'Add Warehouse',
  addAuthorizedWarehouse: 'Add Authorized Warehouse',
  searchAuthorizedWarehouse: 'Search Authorized Warehouse',
  Order: 'Order',
  warehouseNumber: 'Warehouse Number',
  warehouseAbbreviation: 'Warehouse Abbreviation',
  warehouseFullname: 'Warehouse Full-name',
  confirm: 'Confirm',
  searchWarehouse: 'Search Warehouse',
  authorizedWarehouseAdded: 'Authorized Warehouse Added!',
  authorizedWarehouseDeleted: 'Authorized Warehouse Deleted!'
}


// WEBPACK FOOTER //
// ./src/i18n/en/warehouse.js